module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-149.7476967f.svg";